import axios from '../../commons/http/axios';
import { PORTAL_SERVICOS_BACKEND } from '../constants/environment';

export default {
	consultarCep: cep => {
		return axios.get(`${PORTAL_SERVICOS_BACKEND}/v1/dados/cep/consulta/${cep}`).then(res => {
			return res.data;
		});
	},
	consultarEstado: dto => {
		return axios
			.post(`${PORTAL_SERVICOS_BACKEND}/v1/dados/endereco/consulta/uf/`, dto)
			.then(res => {
				return res.data;
			});
	},
	consultarMunicipio: dto => {
		return axios
			.post(`${PORTAL_SERVICOS_BACKEND}/v1/dados/endereco/consulta/municipio/`, dto)
			.then(res => {
				return res.data;
			});
	}
};
